// extracted by mini-css-extract-plugin
export default {"wrap":"TruncatedTooltip_wrap__eKGuH","trigger":"TruncatedTooltip_trigger__fdvpJ","bubble":"TruncatedTooltip_bubble__0HZAL","bubbleIn":"TruncatedTooltip_bubbleIn__pRqNI"};